<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">User Balance Detail</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link>
      /

      <b>Loyalty Point System</b> /

      <b>
        <router-link to="/lps/user-balance"> User Balance </router-link> </b
      >/

      <b>User Balance Detail</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': earned_history }"
            @click="insertEarnedHistory()"
            type="button"
          >
            Earned
          </button>
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': redeemed_history }"
            @click="insertRedeemHistory()"
            type="button"
          >
            Redeemed
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left" v-show="earned_history">
          <div class="card-body">
            <h4 class="card-title mb-3">Earned Details</h4>
            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="row">
              <div class="col-6">
                <label><b>Month</b></label>
                <select class="form-control" v-model="filter_month">
                  <option value="0">Select Month</option>
                  <option
                    v-for="(month, index) in months"
                    :key="index"
                    :value="month.id"
                  >
                    {{ month.name }}
                  </option>
                </select>
              </div>
              <div class="col-6">
                <label><b>Year</b></label>
                <input
                  type="number"
                  class="form-control"
                  v-model="filter_year"
                />
              </div>
            </div>

            <br />

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px"
                @click="onClickFilter()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px"
                @click="resetFilter(1)"
              >
                Reset
              </button>
            </div>

            <br />

            <div class="table-responsive">
              <table
                id="earned_list_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Description</th>
                    <th>Points Earned</th>
                    <th>Earned On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in earned_lists" :key="index">
                    <td width="10%">{{ index + 1 }}</td>
                    <td width="10%">{{ list.description }}</td>
                    <td width="10%">{{ list.points }}</td>
                    <td width="10%">
                      <span class="spanDateTime">{{
                        list.created_at | moment("YYYYMMDD")
                      }}</span
                      >{{ list.created_at | moment("DD/MM/YYYY") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card text-left" v-show="redeemed_history">
          <div class="card-body">
            <h4 class="card-title mb-3">Earned Details</h4>
            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="row">
              <div class="col-6">
                <label><b>Month</b></label>
                <select class="form-control" v-model="filter_month">
                  <option value="0">Select Month</option>
                  <option
                    v-for="(month, index) in months"
                    :key="index"
                    :value="month.id"
                  >
                    {{ month.name }}
                  </option>
                </select>
              </div>
              <div class="col-6">
                <label><b>Year</b></label>
                <input
                  type="number"
                  class="form-control"
                  v-model="filter_year"
                />
              </div>
            </div>

            <br />

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px"
                @click="onClickFilter()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px"
                @click="resetFilter(2)"
              >
                Reset
              </button>
            </div>

            <br />

            <div class="table-responsive">
              <table
                id="redeemed_list_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Points Redeemed</th>
                    <th>Price Redeemed</th>
                    <th>Redeem Info</th>
                    <th>Redeemed On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in redeemed_lists" :key="index">
                    <td width="10%">{{ index + 1 }}</td>
                    <td width="10%">{{ list.points_redeemed }}</td>
                    <td width="10%">{{ list.price_redeemed }}</td>
                    <td width="10%">
                      <span v-if="list.type == 'Vendor'">
                        {{ "Vendor: " + list.vendor.vendor_name }}
                        <br />
                        {{ "Product: " + list.vendor.product_name }}
                      </span>
                      <span v-if="list.type === 'Charity'">
                        {{ "Charity: " + list.charity.name }}
                      </span>
                    </td>
                    <td width="10%">
                      <span class="spanDateTime">{{
                        list.created_at | moment("YYYYMMDD")
                      }}</span
                      >{{ list.created_at | moment("DD/MM/YYYY") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";

export default {
  name: "user-balance",
  components: {
    Pagination,
  },
  data() {
    return {
      earned_lists: [],
      redeemed_lists: [],
      redeemed_history: false,
      earned_history: true,

      filter_year: null,
      filter_month: 0,

      months: [
        { id: 1, name: "January" },
        { id: 2, name: "Febuary" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
      ],
    };
  },

  methods: {
    async loadEarnedData() {
      let token = localStorage.getItem("token");

      let user_id = this.$route.params.user_id;
      // check if has token
      if (token === null || token === "") {
        return false;
      }

      try {
        token = JSON.parse(token);
        token = token.access_token;

        let result = await axios.get(
          axios.lpsURL + `/reward/earn/history/${user_id}`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        this.earned_lists = result.data;
      } catch (e) {
        console.log(e);
      }
    },

    async loadRedeemedData() {
      let token = localStorage.getItem("token");

      let user_id = this.$route.params.user_id;
      // check if has token
      if (token === null || token === "") {
        return false;
      }

      try {
        token = JSON.parse(token);
        token = token.access_token;

        let result = await axios.get(
          axios.lpsURL + `/reward/redeem/history/${user_id}`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        this.redeemed_lists = result.data;
      } catch (e) {
        console.log(e);
      }
    },

    insertRedeemHistory() {
      this.redeemed_history = true;
      this.earned_history = false;
      this.filter_year = null;
      this.filter_month = null;
    },

    insertEarnedHistory() {
      this.redeemed_history = false;
      this.earned_history = true;
      this.filter_year = null;
      this.filter_month = null;
    },

    setDatatable() {
      $("#earned_list_table").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3],
            },
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
            },
          },
        ],
      });

      $("#redeemed_list_table").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
            },
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4],
            },
          },
        ],
      });
    },

    destroyDatatable() {
      $("#earned_list_table").DataTable().destroy();
      $("#redeemed_list_table").DataTable().destroy();
    },

    async filterPoints() {
      let token = localStorage.getItem("token");
      let user_id = this.$route.params.user_id;

      let url = "";

      if (this.filter_month != null && this.filter_year != null) {
        url = this.earned_history
          ? `/reward/earn/history/${user_id}/?filter_month=${this.filter_month}&filter_year=${this.filter_year}`
          : `/reward/redeem/history/${user_id}/?filter_month=${this.filter_month}&filter_year=${this.filter_year}`;
      } else if (
        this.filter_month != null &&
        (this.filter_year == null || this.filter_year == "")
      ) {
        url = this.earned_history
          ? `/reward/earn/history/${user_id}/?filter_month=${this.filter_month}`
          : `/reward/redeem/history/${user_id}/?filter_month=${this.filter_month}`;
      } else if (this.filter_month == null && this.filter_year != null) {
        url = this.earned_history
          ? `/reward/earn/history/${user_id}/?filter_year=${this.filter_year}`
          : `/reward/redeem/history/${user_id}/?filter_year=${this.filter_year}`;
      } else if (
        this.filter_month == null &&
        (this.filter_year == null || this.filter_year == "")
      ) {
        url = this.earned_history
          ? `/reward/earn/history/${user_id}`
          : `/reward/redeem/history/${user_id}`;
      }

      try {
        token = JSON.parse(token);
        token = token.access_token;

        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        if (this.earned_history) {
          this.earned_lists = result.data;
        } else {
          this.redeemed_lists = result.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async resetFilter(int) {
      this.destroyDatatable();

      switch (int) {
        case 1:
          await this.loadEarnedData();
        case 2:
          await this.loadRedeemedData();
      }

      this.setDatatable();

      this.filter_month = 0;
      this.filter_year = null;
    },

    checkMonthSelected() {
      if (this.filter_month == 0) {
        swal({
          icon: "error",
          text: "Please select month",
        });

        return false;
      }

      return true;
    },

    async onClickFilter() {
      if (!this.checkMonthSelected()) {
        return;
      }

      this.destroyDatatable();

      if (this.earned_history) {
        this.earned_lists = [];
      } else {
        this.redeemed_lists = [];
      }

      await this.filterPoints();

      this.setDatatable();

      this.filter_year = null;
    },
  },

  async created() {
    await this.loadEarnedData();
    await this.loadRedeemedData();
    this.setDatatable();
  },
};
</script>

<style>
.spanDateTime {
  display: none;
}

.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
